import styled, { css } from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const Wrapper = styled.div<{
  size: number;
  hoverFilterBackground: boolean;
  backgroundColor: string;
  disabled: boolean;
}>`
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  align-items: center;
  justify-content: center;
  padding: 2px;
  user-select: none;
  cursor: pointer;
  transition: 200ms;
  border-radius: 50%;
  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}

  a {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > span,
  svg {
    transition: 200ms;
  }

  &:hover {
    ${({ hoverFilterBackground }) =>
      hoverFilterBackground
        ? css`
            filter: brightness(1.5);
          `
        : css`
            background-color: ${({ theme }) => theme.neutral100};
          `}
  }
`;
